import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getFollowedCompanies = createAsyncThunk(
  "follows/getFollowedCompanies",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, user } = args;
      let url = `/favourites?page=${page}&size=${size}&type=COMPANY`;

      if (user) {
        url += `&user=${user}`;
      }

      const { data } = await axiosInstance.get(url);
      return thunkApi.fulfillWithValue(data.data ? data : { data: [], itemsCount: 0, pages: 0 });
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response?.data);
    }
  }
);

const followsSlice = createSlice({
  name: "follows",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getFollowedCompanies.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFollowedCompanies.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data || [];
        state.itemsCount = payload.itemsCount || 0;
        state.pages = payload.pages || 0;
      })
      .addCase(getFollowedCompanies.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      });
  }
});

export default followsSlice.reducer;